// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DragPreview18BindJs from "./DragPreview18.bind.js";

var make = DragPreview18BindJs.Preview;

export {
  make ,
  
}
/* make Not a pure module */
